import React from 'react';

export default function Info() {
  return (
    <div className="form-container">
      <h2>Benvenuto nella pagina Info</h2>
      <p><strong>Versione app</strong></p>
      <p><strong>Versione sistema</strong></p>
    </div>
  );
}